module.exports = __webpack_public_path__ + "static/media/faq-erase-data.65151d79.svg";